// extracted by mini-css-extract-plugin
export var backdropBlur = "_ci-0";
export var contentCard = "_ci-5";
export var frame = "_ci-2";
export var image = "_ci-4";
export var imagePane = "_ci-3";
export var modal = "_ci-1";